package uz.ferro.shop.model

import kotlin.js.Date

data class FavoriteUiItem(
    val date: Date,
    val product: Product
)